'use strict';
import textFit from 'textfit';

export const titlesArticles = {
    el: {
        img: document.querySelector('.pHead_wrap > .pHead_media img'),
        title: document.querySelector('.pHead_title, .pHead_subtitle'),
        titleWrapper: document.querySelector('.pHead_title.border.is-visible'),
        paragraph: document.querySelector('.pHead_text p')
    },
    init() {
        if (titlesArticles.el.title) {
            /*this.resizeAll();
            window.addEventListener('resize', this.resizeAll);*/
        }
    },
    resizeAll() {
        const mq = window.matchMedia('screen and (min-width:768px)');

        if (mq.matches && titlesArticles.el.img) {
            titlesArticles.resizetitle();
            titlesArticles.resizeFont();

            //reset la hauteur
            titlesArticles.el.title.style.height = null;

            //
            // titlesArticles.resizeParagraph();
        }
    },
    resizetitle() {
        let imgH = this.el.img.clientHeight;
        let paragraphH = this.el.paragraph.clientHeight;
        let filetH = this.el.title.scrollHeight - this.el.title.clientHeight + 40;
        let titleH = imgH - paragraphH - filetH;
        titleH < 50 ? (titleH = 50) : null;
        this.el.title.style.height = titleH + 'px';
        // console.log(`Resize Title = img:${imgH}`, `- paragraph : ${paragraphH}`, `- filet ${filetH}`, titleH);
    },
    resizeFont() {
        textFit(this.el.title, {
            minFontSize: 24,
            maxFontSize: 70,
            detectMultiLine: true // disable to turn off automatic multi-line sensing
        });
    },
    resizeParagraph() {
        if (this.el.img.clientHeight - document.querySelector('.pHead_content').clientHeight <= 0) {
            this.el.paragraph.style.fontSize = '14px';
        }
    }
};



// WEBPACK FOOTER //
// ./src/scripts/general/text.js